import { BaseController } from "../BaseController";
import { EventControllerInterface } from "@game.object/ts-game-toolbox/dist/src/abstract/mvc/Controller";
import { ControllerRouteResponse } from "@game.object/ts-game-toolbox/dist/src/abstract/mvc/ControllerRouteResponse";

export class GameEventController extends BaseController implements EventControllerInterface {
    public selected_block_id: number | null = null;

    public update(delta_seconds: number): ControllerRouteResponse {
        if (this.models.blockchain.is_computing) {
            this.models.blockchain.compute();
        }
        this.models.blocks.for_each((block) => {
            if (block.is_computing_hash) block.mine();
        })
        return null;
    }

    public mouse_pressed(event: MouseEvent) {
        if (!(event.target instanceof HTMLCanvasElement)) return null;
        const rect = event.target.getBoundingClientRect();
        const collums = Math.ceil(Math.sqrt(this.models.blocks.all().length));
        const xi = Math.trunc((event.x - rect.left) / rect.width * collums);
        const yi = Math.trunc((event.y - rect.top) / rect.height * collums);
        const block_id = xi + yi * collums;
        if (this.selected_block_id === null) {
            this.selected_block_id = block_id;
            return null;
        } else {
            this.models.blockchain.select(this.selected_block_id, block_id);
            this.models.blockchain.request_compute();
            this.selected_block_id = null;
            return this.views.main.chained_block_ids.set(this.models.blockchain.block_ids);
        }
    }

    public key_pressed(event: KeyboardEvent) {
        const blocks = this.models.blocks.all();
        const last_block = blocks[blocks.length - 1] || { hash: 0 };
        const new_block = this.models.blocks.insert_new();
        new_block.previous_hash = last_block.hash;
        new_block.data = "--------" + event.code + "--------";
        new_block.mine();
        return this.views.main.blocks.set(this.models.blocks.all());
    }
}